module.exports = {
  STRAPI_URL: 'https://embe.iteas.dev',
  cacheExpires: process.env.NODE_ENV === 'production' ? 24 * 3600 * 1000 : 1000 * 10,
  //cacheExpires: 1000 * 10,
  MARKDOWN_FIELDS: ['text', 'textBox', 'bio'],
  DEFAULT_LANGUAGE: 'eng'
};